import { Dataset } from '../types/types';

export const isMandatoryFilter = (
  dataset: Dataset,
  name: string,
  datasetId: string
): boolean =>
  datasetId === dataset?.datasetId &&
  !!dataset?.filterFirst?.mandatory?.includes(name);
